  <bzg-welcome-landing topTitle="{{ 'AUTOADMIN.TOP_TITLE' | translate }}" middleTitle="{{ 'AUTOADMIN.MIDDLE_TITLE' | translate }}" bottomTitle="{{ 'AUTOADMIN.BOTTOM_TITLE' | translate }}">
    <form #changePasswordForm="ngForm" class="bmc-change-password" (ngSubmit)="changePassword()">
        <label class="bmc-change-password__username-title">{{ 'AUTOADMIN.USER_NAME' | translate }}</label>
        <label class="bmc-change-password__username-text">{{ userName }}</label>
        <p class="bmc-change-password__description">{{ 'AUTOADMIN.CHANGE_PASSWORD_DESCRIPTION' | translate }}</p>
        <bzg-password name="password" [(ngModel)]='password' class="bmc-change-password__input"
            infoText="{{ 'AUTOADMIN.PASSWORD_CASE_SENSITIVE' | translate }}" [hasCustomErrors]='!testRegEx()'>
            {{ 'AUTOADMIN.NEW_PASSWORD' | translate }}
            <bzg-custom-error>{{ 'AUTOADMIN.PASSWORD_DOESNT_MEET_REQUIREMENTS' | translate }}</bzg-custom-error>
        </bzg-password>
        <bzg-password name="passwordConfirmation" [(ngModel)]='verificationPassword' class="bmc-change-password__input"
            infoText="{{ 'AUTOADMIN.PASSWORD_CASE_SENSITIVE' | translate }}" [hasCustomErrors]="verificationPassword !== password">
            {{ 'AUTOADMIN.CONFIRM_PASSWORD' | translate }}
            <bzg-custom-error >{{ 'AUTOADMIN.PASSWORD_DOESNT_MATCH' | translate }}</bzg-custom-error>
        </bzg-password>
        <button type="submit" [hidden]="true"></button>
    </form>
    <div class="bmc-change-password__button">
        <bzg-button-primary (click)="changePassword()" [disabled]="isPasswordInvalid()">{{ 'AUTOADMIN.NEXT' | translate }}</bzg-button-primary>
    </div>
  </bzg-welcome-landing>
